import { queryOptions } from "@tanstack/react-query";
import { experienceApi } from "@/lib/api";
import { onboardingKeys } from "./query-keys";

export type OnboardingStep = {
  id: string;
  label: string;
  complete: boolean;
};

export type OnboardingProgressResponse = {
  /** @deprecated Use dismissed and account_has_executed_tool_externally instead. `steps` will be removed with the developer-based onboarding code in the "first win onboarding" project. */
  steps: OnboardingStep[];
  dismissed: boolean;
  account_has_executed_tool_externally: boolean;
} | null;

const fetchOnboardingProgress = async (
  orgId?: string,
  projectId?: string
): Promise<OnboardingProgressResponse> => {
  const res = await experienceApi.get<OnboardingProgressResponse>(
    "/api/onboarding",
    { params: { orgId, projectId } }
  );
  return res.data ?? null;
};

export const onboardingProgressQueryOptions = (
  orgId?: string,
  projectId?: string
) =>
  queryOptions({
    queryKey: onboardingKeys.progress(orgId, projectId),
    queryFn: () => fetchOnboardingProgress(orgId, projectId),
    refetchInterval: (query) =>
      query.state.data == null || query.state.data.dismissed ? false : 15_000,
  });
